export const SET_SERVICE_ORDERS = 'OPERATIONAL_HISTORY/SET_SERVICE_ORDERS';
export const TOGGLE_SERVICE_ORDER = 'OPERATIONAL_HISTORY/TOGGLE_SERVICE_ORDER';
export const HANDLE_LOADING = 'OPERATIONAL_HISTORY/HANDLE_LOADING';
export const HANDLE_RESUME_LOADING = 'OPERATIONAL_HISTORY/HANDLE_RESUME_LOADING';
export const SET_RESUME_SERVICE_ORDERS = 'OPERATIONAL_HISTORY/SET_RESUME_SERVICE_ORDERS';
export const SET_PAID_SERVICE_ORDERS = 'OPERATIONAL_HISTORY/SET_PAID_SERVICE_ORDERS';
export const HANDLE_PAID_SERVICE_ORDERS_LOADING = 'OPERATIONAL_HISTORY/HANDLE_PAID_SERVICE_ORDERS_LOADING';